import { useContext } from "react";

import { useLearnContext } from "../../../../context/LearnContext";
import TournamentContentInfo from "../../../Tournament/Components/TournamentContentInfo";
import LessonInfo from "../../LessonInfo";
import ExerciseInstructions from "../RightPanel/Exercise/ExerciseInstructions";
import { VideoContext } from "../VideoContext";
import ActionPane from "./ActionPane";

export default function LeftPanel({ lessonDetails }) {
  const { isTournament } = useLearnContext();
  const { exerciseOnly, inExerciseMode } = useContext(VideoContext);

  return (
    <div className="flex flex-col gap-9">
      {!isTournament ? (
        <LessonInfo
          lessonType={lessonDetails.type}
          title={lessonDetails.title}
          description={lessonDetails.description}
          level={lessonDetails.level}
          duration={lessonDetails.duration}
        />
      ) : (
        <TournamentContentInfo
          lessonType={lessonDetails.type}
          title={lessonDetails.title}
          description={lessonDetails.description}
        />
      )}

      {!exerciseOnly && <ActionPane hasExercise={lessonDetails.hasExercise} />}

      {inExerciseMode && (
        <div className="w-full">
          <ExerciseInstructions lessonDetails={lessonDetails} />
        </div>
      )}
    </div>
  );
}
